window.addEventListener('DOMContentLoaded', () => {
    const contentListerSwiper = document.querySelectorAll('.content-lister-swiper');

    if (contentListerSwiper.length) {
        [].forEach.call(contentListerSwiper, (grid) => {
            const gridContainerInner = grid.querySelector('.content-lister-swiper__inner');

            const handleSwiperClasses = (value) => {
                const gridContainer = grid.querySelector('.content-lister-swiper__items');
                const gridContainerItems = grid.querySelector(
                    '.content-lister-swiper__items',
                ).children;

                console.log('gridContainerItems', gridContainerItems);

                if (value === 'add') {
                    gridContainer.classList.add('swiper-wrapper');
                    [].forEach.call(gridContainerItems, (item) => {
                        item.classList.add('swiper-slide');
                    });
                }

                if (value === 'remove') {
                    gridContainer.classList.remove('swiper-wrapper');
                    [].forEach.call(gridContainerItems, (item) => {
                        item.classList.remove('swiper-slide');
                    });
                }
            };

            const checkBreakpoint = () => {
                const breakpointMediumDown = window.matchMedia('(max-width: 1025px)');
                let swiperActive;

                if (breakpointMediumDown.matches) {
                    swiperActive = true;
                    return swiperActive;
                } else {
                    swiperActive = false;
                    return swiperActive;
                }
            };

            const activateSwiper = (swiperInstance) => {
                let swiper = swiperInstance.swiper;
                if (checkBreakpoint()) {
                    if (swiper == null) {
                        handleSwiperClasses('add');
                        new Swiper(swiperInstance, {
                            slidesPerView: 'auto',
                            watchOverflow: true,
                            pagination: {
                                el: '.swiper-pagination',
                                type: 'bullets',
                                clickable: true,
                            },
                            navigation: {
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev',
                            },
                        });
                    }
                } else {
                    if (swiper != null) {
                        handleSwiperClasses('remove');
                        swiper.destroy();
                    }
                }
            };

            activateSwiper(gridContainerInner);

            window.addEventListener('resize', () => {
                activateSwiper(gridContainerInner);
            });
        });
    }
});
